// proper handling of negative values, e.g., -1 % 6 = 5
export const mod = (n: number, m: number) => {
  return ((n % m) + m) % m;
};
